import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "editar",
		transform: "translate(-69.509 3341.726)",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Elipse_32",
			"data-name": "Elipse 32",
			cx: 10,
			cy: 10,
			r: 10,
			transform: "translate(69.509 -3341.726)",
			fill: "#7fb02f"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "edit_note_black_24dp",
			transform: "translate(71.924 -3339.311)",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rect\\xE1ngulo_606",
				"data-name": "Rect\\xE1ngulo 606",
				width: 16,
				height: 16,
				transform: "translate(-0.415 -0.414)",
				fill: "none"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Trazado_6743",
				"data-name": "Trazado 6743",
				d: "M3,8.482H9.827V9.724H3ZM3,7.241H9.827V6H3Zm0,4.965H7.344V10.965H3Zm9.315-1.943.441-.441a.618.618,0,0,1,.875,0l.441.441a.618.618,0,0,1,0,.875l-.441.441Zm-.441.441L8.586,13.994v1.316H9.9l3.289-3.289Z",
				transform: "translate(-1 -2.138)",
				fill: "#fff"
			})]
		})]
	})]
});
const ForwardRef = forwardRef(SvgEditar);
export { ForwardRef as ReactComponent };
